var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-content',{attrs:{"title":"Page not found","subtitle":"Where am I?","showHeader":_vm.isAuthenticated}},[_c('div',{staticClass:"page-not-found"},[_c('img',{attrs:{"src":"/images/brdrone.png","srcset":"/images/brdrone.webp" + ", " + "/images/brdrone.png","alt":"page not found"}})])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }